import { render, staticRenderFns } from "./SelectGoods.vue?vue&type=template&id=7f143326&scoped=true"
import script from "./SelectGoods.vue?vue&type=script&lang=ts"
export * from "./SelectGoods.vue?vue&type=script&lang=ts"
import style0 from "./SelectGoods.vue?vue&type=style&index=0&id=7f143326&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f143326",
  null
  
)

export default component.exports